import { RSAA } from 'redux-api-middleware';
import type { RSAACallRequest } from '@makemydeal/dr-react-18-wrappers';
import { MANAGER_VIEW_APP_PREFIX, apiConfigHelper, locHrefUtil } from '@makemydeal/dr-shared-ui-utils';
import {
    REPORT_ISSUE_REQUEST,
    REPORT_ISSUE_SUCCESS,
    REPORT_ISSUE_FAILURE,
    REPORT_ISSUE_RESET
} from '../actionTypes/reportIssueActionTypes';

export type ReportIssuePayload = {
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
    dealerName: string;
    accountId: string | number;
    preferredContact: string;
    additionalUrls: string;
    additionalContacts: string;
    subject: string;
    priority: string;
    message: string;
    type: string;
    examples: string;
    dealerId: string | number;
    commonOrgId: string;
    userName: string;
    dealXgId: string;
    customerName: string;
};

export const reportIssueRSAA = (payload: ReportIssuePayload) => {
    return (dispatch: any) => {
        const locHref = locHrefUtil.getLocHref();
        const bffApiUrlResult = apiConfigHelper.buildBffApiUrl(MANAGER_VIEW_APP_PREFIX, locHref, '/reportIssue');
        const request: RSAACallRequest = {
            endpoint: bffApiUrlResult.url,
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
            types: [REPORT_ISSUE_REQUEST, REPORT_ISSUE_SUCCESS, REPORT_ISSUE_FAILURE],
            fetch: async (...args) => await fetch(...args)
        };
        return dispatch({ [RSAA]: request });
    };
};

export const resetReportIssue = () => ({
    type: REPORT_ISSUE_RESET
});
